import { render, staticRenderFns } from "./EventosTabela.vue?vue&type=template&id=34d9c679"
import script from "./EventosTabela.vue?vue&type=script&lang=js"
export * from "./EventosTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports